<dsd-container *ngIf="isCapacityCompleted$ | async">
  <h4 class="dsd-t-4">{{ 'capacite.conseils-preautorisation.titre' | translate }}</h4>
  <ng-container [ngSwitch]="statutCapacite$ | async">
    <ng-container *ngSwitchCase="StatusCapaciteEnum.Haute" [ngTemplateOutlet]="haute"></ng-container>
    <ng-container *ngSwitchCase="StatusCapaciteEnum.Basse" [ngTemplateOutlet]="basse"></ng-container>
    <ng-container *ngSwitchCase="StatusCapaciteEnum.RealisteMaximale" [ngTemplateOutlet]="avecResultat"></ng-container>
    <ng-container
      *ngSwitchCase="StatusCapaciteEnum.RealisteEgaleMaximale"
      [ngTemplateOutlet]="avecResultat"
      [ngTemplateOutletContext]="{ hideCapaciteMaximale: true }"
    ></ng-container>
  </ng-container>
  <p
    class="dsd-mb-0 max-width-1060"
    [innerHTML]="
      'capacite.conseils-preautorisation.recalculer-capacite.' +
        ((isPreautorisationCoemprunteur$ | async) ? 'inclure-coemprunteur' : 'exclure-coemprunteur') | translate
    "
  ></p>
</dsd-container>

<ng-template #avecResultat let-hideCapaciteMaximale="hideCapaciteMaximale">
  <ng-container *ngIf="donneesResultat$ | async as donneesResultat">
    <p
      [innerHTML]="
        'capacite.conseils-preautorisation.rester-proche-realiste'
          | translate: { valeurProprieteRealiste: donneesResultat.valeurProprieteRealiste | desjardinsCurrency }
      "
    ></p>
    <dsd-grid-row>
      <dsd-grid-col sm-col="6">
        <app-card class="mb-24-16" theme="turquoise">
          <h5 header class="dsd-t-5 dsd-mb-0">
            {{ 'capacite.conseils-preautorisation.capacite-realiste' | translate }}
          </h5>
          <div class="amount">
            {{ donneesResultat.valeurProprieteRealiste | desjardinsCurrency }}
          </div>
        </app-card>
      </dsd-grid-col>
      <dsd-grid-col *ngIf="!hideCapaciteMaximale" sm-col="6">
        <app-card class="mb-16" theme="yellow">
          <h5 header class="dsd-t-5 dsd-mb-0">
            {{ 'capacite.conseils-preautorisation.capacite-maximale' | translate }}
          </h5>
          <div class="amount">
            {{ donneesResultat.valeurProprieteMaximale | desjardinsCurrency }}
          </div>
        </app-card>
      </dsd-grid-col>
    </dsd-grid-row>
  </ng-container>
</ng-template>

<ng-template #basse>
  <p class="max-width-1060" [innerHTML]="'capacite.conseils-preautorisation.capacite-basse' | translate"></p>
</ng-template>

<ng-template #haute>
  <p class="max-width-1060" [innerHTML]="'capacite.conseils-preautorisation.capacite-haute' | translate"></p>
</ng-template>
